import { getCustomService } from '../../helpers/ReduxHelpers'

export const changeStartDateOfPlanService = getCustomService<
  'changeStartDateOfPlan',
  any,
  any
>('changeStartDateOfPlan')
